'use strict';

const Action = require('./Action');

/**
 * @typedef {object} ExportedFilterAction
 *
 * @property {string}   func  Nombre de la función: filter
 * @property {Array}    args  Argumentos de entrada a la función:
 *                            - el ID del campo
 *                            - la lista de opciones disponibles
 * @property {string[]} scope Los ámbitos de ejecución de la acción
 */

/**
 * Clase de gestión de una regla de tipo Filtrar opciones de valor disponibles
 *
 * @extends {Structure.Action}
 *
 * @memberOf Structure
 */
class FilterAction extends Action {
    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.type = Action.Types.FILTER;
        this.function = 'filterOptions';

        this.options = rawAction.options || [];
        this.cleanUp = !!rawAction.cleanUp;
    }

    /**
     * Includes option value
     *
     * @param  {String}  optionValue Option value
     *
     * @return {Boolean}             TRUE if option is included in this action
     */
    includesOptionValue(optionValue) {
        return this.options.indexOf(optionValue) > -1;
    }

    /**
     * Exportación de la acción en un objeto para la ejecución de las reglas
     *
     * @return {ExportedFilterAction} Objeto de exportación de la acción
     */
    export() {
        const rawAction = super.export();
        rawAction.options = this.options;
        rawAction.cleanUp = this.cleanUp;

        return rawAction;
    }
}

module.exports = FilterAction;
